import { UseCasesTabs } from "@/features/use-cases/components/use-cases-tabs"

export function UseCasesDashboardPage() {
  return (
    <div className="mx-auto w-full max-w-7xl p-6 md:p-8">
      <UseCasesTabs />
    </div>
  )
}
